import { useState } from "react";

export type FilterOption = {
  key: string;
  title: string;
  count?: number;
};

export type FilterDropdownProps = {
  options: FilterOption[];
  value: string;
  onChange: (key: string) => void;
  badgeCount?: number;
};

/** Historical tertiary filter dropdown (`ne__dropdown` + `ne__btn--tertiary`). */
export function FilterDropdown({
  options,
  value,
  onChange,
  badgeCount,
}: FilterDropdownProps) {
  const [open, setOpen] = useState(false);
  const active = options.find((o) => o.key === value) || options[0];

  return (
    <div className={`ne__dropdown${open ? " open" : ""}`}>
      <button
        type="button"
        className="ne__btn ne__btn--tertiary ne__btn--md"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span>{active?.title}</span>
        {badgeCount != null && badgeCount > 0 ? (
          <span className="ne__badge ne__badge--num">{badgeCount}</span>
        ) : null}
        <i className="ne__icon__arrow--dropdown--thicker" />
      </button>
      {open ? (
        <ul className="ne__dropdown__menu ne__dropdown__menu--primary">
          {options.map((opt) => (
            <li key={opt.key}>
              <a
                className={`ne__dropdown__item${value === opt.key ? " active" : ""}`}
                href={`#${opt.key}`}
                onClick={(e) => {
                  e.preventDefault();
                  onChange(opt.key);
                  setOpen(false);
                }}
              >
                <span>{opt.title}</span>
                {opt.count != null && opt.count > 0 ? (
                  <span className="ne__badge ne__badge--num">{opt.count}</span>
                ) : null}
              </a>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
